import {
  QueryClient,
} from "@tanstack/react-query";
import axios from "axios";
import { InvalidSessionError, onSessionExpired } from "./session-expiration";

function shouldRetryQuery(
  failureCount: number,
  error: unknown,
) {
  if (error instanceof InvalidSessionError) return false;
  if (failureCount >= 1) {
    return false;
  }

  if (!axios.isAxiosError(error)) {
    return true;
  }

  const status = error.response?.status;

  if (!status) {
    return true;
  }

  if (
    status === 401 ||
    status === 403 ||
    status === 404
  ) {
    return false;
  }

  return status >= 500;
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      retry: shouldRetryQuery,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
    },
    mutations: {
      retry: false,
    },
  },
});

// This hostname-selected client holds authenticated server state only; public forms
// do not use it. Clear mutations as well as queries when identities change.
export function clearAuthenticatedCache() {
  void queryClient.cancelQueries();
  queryClient.clear();
}

onSessionExpired(clearAuthenticatedCache);
